import {put, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {replaceQuestion, setQuestion} from "../../game/actions";
import {enterQuestion} from "../../questions/actions";
import {IQuestionProgress} from "../../questions/types";

type StateSlice = {
    questionProgress: Record<number, IQuestionProgress>;
    unusedQuestions: number[];
    currentQuestionId: number;
};

export default function* () {
    const {questionProgress, unusedQuestions, currentQuestionId}: StateSlice = yield select(({ game, questions }: IApplicationState) => ({
        unusedQuestions: game.unusedQuestions,
        currentQuestionId: questions.currentQuestionId,
        questionProgress: questions.progress
    }));

    if (!unusedQuestions.length)
        return false;

    let replaceWith;

    while (!replaceWith && unusedQuestions.length) {
        const question = unusedQuestions.shift();
        if (!question) {
            continue;
        }

        yield put(setQuestion(question));

        if (questionProgress[question]) {
            continue;
        }

        replaceWith = question;
    }

    if (!replaceWith) {
        return false;
    }

    yield put(replaceQuestion({
        current: currentQuestionId,
        replaceWith: replaceWith
    }));

    yield put(enterQuestion(replaceWith));

    return true;
}